import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { InitialStateRequest } from './TypesRequestScreen';

const initialStateLanguage: InitialStateRequest = {
  isLoading: false,
  data: [],
  error: false
}

const headers = {
  Authorization: 'Bearer 104|21iWYH6gMshO8wPvVEyBx5a5NSLSyoYevjYD3bJE4286b42f',
  'Content-Type': 'multipart/form-data'
};
const urlApi = 'https://api-staging.offshore2go.com/api/companies/services-requests?companyId=6'

export const getRequestScreen = createAsyncThunk('getRequestScreen', 
  async (thunkAPI) => {
    const response = await fetch(urlApi, {
      method: 'GET',
      headers
    })

    const data = response.json();
    return data
})

export const requestScreenSlice = createSlice({
  name: 'requestScreen',
  initialState: initialStateLanguage,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRequestScreen.pending, (state, action) => {
      state.isLoading = true
    });
    builder.addCase(getRequestScreen.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    });
    builder.addCase(getRequestScreen.rejected, (state, action) => {
      state.error = true;
    })
  },
})


export default requestScreenSlice.reducer;